module.exports = "/images/project-deliverable-white.svg?43c96d06cd250513c428b4f91f8b0d00";